// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-safety"},"nodeName":"g","children":[{"attributes":{"id":"fill2","fill":"transparent","d":"M14.498 14.5C16.8935 14.5 19.1026 14.5 21.498 14.5V19.1336C21.498 19.8089 21.1572 20.4387 20.5919 20.808L17.998 22.5024L15.4042 20.808C14.8389 20.4387 14.498 19.8089 14.498 19.1336V14.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20 10.5V7L15 2H4V22H10.5M14 2V8H20","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14.498 14.5C16.8935 14.5 19.1026 14.5 21.498 14.5V19.1336C21.498 19.8089 21.1572 20.4387 20.5919 20.808L17.998 22.5024L15.4042 20.808C14.8389 20.4387 14.498 19.8089 14.498 19.1336V14.5Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-safety')
export default class FileSafetyIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-safety',
    }
  }
}
